import { render, staticRenderFns } from "./downloadButtom.vue?vue&type=template&id=48a39718&scoped=true"
import script from "./downloadButtom.vue?vue&type=script&lang=js"
export * from "./downloadButtom.vue?vue&type=script&lang=js"
import style0 from "./downloadButtom.vue?vue&type=style&index=0&id=48a39718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_css-loader@6.11.0_webpack@5.95.0__lodash@4.17.21__mu2kzy4yce77og2lygjn7k5jt4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a39718",
  null
  
)

export default component.exports